export default { TrackPoint, Logger };

import common from 'common';
import { Logger } from 'limi-lib/dist/lib/limi/log/Logger';
import { TrackPoint } from 'limi-lib/dist/lib/limi/log/TrackPoint';
import utils from 'utils';
const eventConfig = {
  LMTrackEventLaunchInfo: '3101', // 冷启动时候 app 信息
  LMTrackEventAppState: '3202', // 前后台切换状态
  LMTrackEventUpdate: '3203', // 点击升级按钮
  LMTrackEventUpdateCancel: '3287', //点击取消升级按钮
  LMTrackEventLogin: '3204', // 点击登录按钮
  LMTrackEventLoginSuccess: '3205', // 登录成功
  LMTrackEventLogout: '3206', // 退出登录
  LMTrackEventClassCardClicked: '3207', // 班级卡片点击
  LMTrackEventLessonCardClicked: '3208', // 课时卡片点击
  LMTrackEventLivingin: '3209', // 直播提醒点击
  LMTrackEventMyBadge: '3210', // 我的徽章界面
  LMTrackEventClassBadge: '3211', // 小班徽章
  LMTrackEventSwitchClass: '3212', // 切换小班
  LMTrackEventSwitchIcon: '3213', // 更换头像
  LMTrackEventPlayBackTag: '3214', // 视频回放 Tag
  LMTrackEventLaunchTime: '3215', // app 启动时间
  LMTrackEventDanmu: '3216', // 弹幕表情统计
  LMTrackEventDanmuReceive: '3237', // 接收自己弹幕
  LMTrackEventReceiveQuestion: '3217', // 收到题目
  LMTrackEventShowQuestion: '3218', // 题目展示
  LMTrackEventAnswer: '3219', // 点题点击
  LMTrackEventrReceiveCoin: '3235', // 收到金币消息
  LMTrackEventAnswerRightCoin: '3220', // 答对自动加金币动画
  LMTrackEventGlobalCoin: '3221', // 全体加金币
  LMTrackEventAnswerExcelentCoin: '3233', // 选项金币
  LMTrackEventStudentExcelentCoin: '3234', // 排行榜金币
  LMTrackEventAddCoinComplete: '3236', // 完成加金币
  LMTrackEventSetBanned: '3222', // 禁言
  LMTrackEventCancelBanned: '3223', // 取消禁言
  LMTrackEventLiveStateChange: '3224', // 直播导播状态变更
  LMTrackEventReceiveBadge: '3225', // 收到徽章
  LMTrackEventReceiveEva: '3226', // 收到评价
  LMTrackEventCancelEva: '3227', // 取消评价
  LMTrackEventStreamChange: '3228', // 播放器切流
  LMTrackEventKick: '3229', // 踢人
  LMTrackEventLivingOut: '3230', // 退出直播
  LMTrackEventGameClicked: '3231', // 小游戏入口
  LMTrackEventGameCard: '3232', // 小游戏列表
  LMTrackEventWXShare: '3238', // 点击微信分享
  LMTrackEventUnzip: '3240', // zip资源包解压
  LMTrackEventJSUnzip: '3241', // js zip 资源包解压
  LMTrackEventWebViewInit: '3242', // 新建 webview
  LMTrackEventWebViewStart: '3243', // 交互课件开启
  LMTrackEventWebViewClose: '3244', // 交互课件关闭
  LMTrackEventWebViewWebCL: '3245', // 交互课件加载失败
  LMTrackEventWebViewIndex: '3246', // index 事件
  LMTrackEventWebViewMarklog: '3247', // 课件内部日志
  LMTrackEventSocketConnect: '3248', // 长连接开始连接
  LMTrackEventSocketSuccess: '3249', // 长连接连接成功
  LMTrackEventSocketFailure: '3250', // 长连接连接失败
  LMTrackEventSocketClose: '3251', // 长连接连接断开
  LMTrackEventPing: '3252', // ping
  LMTrackEventAPI: '3253', // API
  LMTrackEventStreamLose: '3254', // 直播断流
  LMTrackEventStreamCaton: '3255', // 直播卡顿
  LMTrackEventPlayerRestart: '3256', // 直播重启播放器
  LMTrackEventLiveRank: '3257', // 直播排行榜
  LMTrackEventPreTest: '3258', // 课前测结果统计
  LMTrackEventNoNetToast: '3259', // 无网提示
  LMTrackEventTimeOutPop: '3260', // 网络慢，弹框提示
  LMTrackEventFailureButton: '3261', // 获取失败，点击重试按钮
  LMTrackEventPlayerError: '3262', // 播放器异常信息
  LMTrackEventLiveStreamInfo: '3263', // 播放器流信息
  LMTrackEventEyesSafeOpen: '3264', // 护眼开启
  LMTrackEventEyesSafeClose: '3265', // 护眼关闭
  LMTrackEventLivingCancel: '3266', // 课时列表页取消直播按钮点击
  LMTrackEventLoginError: '3267', // 密码错误
  LMTrackEventLivingHideDanmu: '3268', // 隐藏弹幕
  LMTrackEventLivingShowDanmu: '3269', // 显示弹幕
  LMTrackEventCoinClick: '3270', // 金币点击

  /*
   页面事件
  **/

  LMTrackEventClassPage: '3301', // 班级列表页
  LMTrackEventInfoPage: '3302', // 个人信息页
  LMTrackEventVersionNotice: '3303', // 软件更新提示
  LMTrackEventLivingNotice: '3304', // 直播提醒
  LMTrackEventLoginNumPage: '3305', // 登录账号页
  LMTrackEventLoginPassPage: '3306', // 登录密码页
  LMTrackEventLessonPage: '3307', // 课时列表页
  LMTrackEventPlayBackPage: '3308', // 视频回放页
  LMTrackEventLivingPage: '3309', // 直播页
  LMTrackEventGamePage: '3310', // 小游戏列表页
  LMTrackEventLaunchPage: '3311', // 启动页
  LMTrackEventLittleGameStar: '3312', // 小游戏开始
  LMTrackEventLittleGameEnd: '3313', // 小游戏结束
  LMTrackEventVideoPage_start: '3401', // 进入回放页
  LMTrackEventVideoPage_end: '3402', // 退出回放页
  LMTrackEventVideoPage_point: '3403', // 回放页锚点
  LMTrackEventViewingTime: '3288', //观看视频时长
  //2.53新增埋点
  LMTrackEventNetClick: '3271', //直播网络监测点击
  LMTrackEventFeedBack: '3272', //问题反馈                                                1
  LMTrackEventFbResult: '3273', //提交问题反馈结果
  LMTrackEventEquminetClick: '3274', //个人中心设备监测点击
  LMTrackEventEqumentResult: '3275', //个人中心设备监测结果
  LMTrackEventUpdateInMy: '3276', //个人中心点击版本更新
  LMTrackEventUpdateNow: '3277', //个人中心进行版本更新
  LMTrackEventPrivacyClick: '3278', //个人中心隐私政策点击
  LMTrackEventUserInfoRecordPublicit: '3291', //备案公示点击
  LMTrackEventContactUs: '3279', //个人中心联系我们点击
  LMTrackEventMessageBtnClick: '3280', //消息入口点击
  LMTrackEventMesssageView: '3281', //消息查看
  //2.5.6新增
  LMTrackEventVideoQSSuccess: '3282', // 语音答题成功
  LMTrackEventVideoUploadFailure: '3283', // 语音上传失败
  LMTrackEventVideoQSFailure: '3284', // 语音答题失败

  LMTrackEventTYKSeekTime: '3285', // 体验课时间埋点
  LMTrackEventAISwitchStream: '3286',
  LMTrackEventNetworkCaton: '4001', // 网络卡顿

  //连麦
  LMTrackEventTelDevice: '3292', // 连麦时麦克风状态
  LMTrackEventTelCall: '3293', // 兼课端发起连麦
  LMTrackEventTelAnswer: '3294', // 同意连麦请求
  LMTrackEventTelError: '3295', // 连麦请求超时
  LMTrackEventTelJoin: '3296', // 客户端加入频道_声网
  LMTrackEventTelLeave: '3297', // 客户端退出频道_声网
  LMTrackEventTelOtherJoin: '3298', // 远端加入频道_声网
  LMTrackEventTelOtherLeave: '3299', // 远端退出频道_声网
  LMTrackEventTelOver: '3501', // 兼课端挂断连麦
  LMTrackEventAgoraRtcErrorCode: '3503', //声网错误码

  //2.7.4
  LMTrackEventRankTask: '3504', // 排行榜指令消息
  LMTrackEventSendRankReq: '3505', // 发送获取排行榜数据请求
  LMTrackEventRankData: '3506', // 接收排行榜数据
  LMTrackEventSinglePraise: '3507', // 收到单人表扬数据
  LMTrackEventBatchPraiseTask: '3508', // 收到批量表扬任务指令
  LMTrackEventBatchPraiseReq: '3509', // 发送获取批量表扬数据请求
  LMTrackEventBatchPraiseData: '3510', // 收到批量表扬数据
  LMTrackEventEncourage: '3511', // 收到鼓励消息
  LMTrackEventGiftSwitchTask: '3512', // 收到礼物展示隐藏指令
  LMTrackEventSendGift: '3513', // 客户端赠送礼物
  LMTrackEventSendGiftCallBack: '3514', // 赠送礼物回调消息

  //276
  LMTrackEventSwitchTextStyle: '3515', // 切换弹幕配置色
  LMTrackEventPKTaskMessage: '3516', // PK指令
  LMTrackEventPKSendMessage: '3517', // PK上行请求业务数据
  LMTrackEventPKBusinessMessage: '3518', // PK下行业务数据

  //280语音评测服务商切换
  LMTrackEventSwitchSoe: '3534', //切换厂商指令
  LMTrackEventSendSoe: '3535', //发送获取语音评测厂商指令
  LMTrackEventSwitchSoeResult: '3536', //收到语音评测厂商数据

  // 2.8.4
  LMTrackEventSwitchLiandui: '3538', //连对开关切换
  LMTrackEventSwitchHeadwear: '3539', //切换头饰
  LMTrackEventScreeCapture: '3540', //截图

  //2.9.0
  LMTrackEventOssDQuesImgUploadSuccess: '3542', //画图题图片上传成功
  LMTrackEventOssDQuesImgUploadfail: '3543', //画图题图片上传失败
};
let device_id = utils.createDeviceId();
let os_version = utils.getBrowserVersion();
if (LIMI_ENV === 'electron') {
  device_id = common.get('pc_h5_device_id');
  try {
    os_version = nodeRequire('os').release();
  } catch (error) {}
}
let baseData = {
  device_id: device_id,
  app_type: 1,
  app_os: common.device,
  screen_width: utils.getClientWidth(),
  screen_height: utils.getClientHeight(),
  device_type: common.device,
  os_version: os_version,
  device_name: utils.getSystemInfo(),
};
function writeHeader(header) {
  window.localStorage.setItem('logHeader', JSON.stringify(header));
}

function readHeader() {
  return JSON.parse(window.localStorage.getItem('logHeader'));
}

// 自动埋点数据2次封装
function onLimiTrack(type, xpath, comment) {
  const autoLog = {
    log_type: '1',
    app_version: common.version + '.0', //todo
    m_channel: '',
    network_type: '',
    log_time: common.getTemServerTime() + '',
    LANIP: common.LANIP, //内网ip
    WANIP: common.WANIP, //外网IP
    event_type: type,
    event_info: xpath,
    class_name: window.location.href,
    method_name: comment,
  };
  return autoLog;
}

// 业务日志
function createBLog(data) {
  let commonData = {
    log_type: '2',
    app_version: common.version + '.0',
    m_channel: '',
    network_type: '',
    log_time: common.getTemServerTime() + '',
    LANIP: common.LANIP, //内网ip
    WANIP: common.WANIP, //外网IP
    user_id: (common.getSession('userID') || '') + '',
    course_id: (common.getSession('class_id') || '') + '',
    sclass_id: (common.getSession('smallClassId') || '') + '',
    hmaster_id: '',
    teacher_id: (common.getSession('teacher_id') || '') + '',
    lesson_id: (common.getSession('lesson_id') || '') + '',
    biz_id: eventConfig[data.id] || data.id,
    biz_data: data.data || {},
  };
  let durationData = {
    log_type: '2',
    app_version: common.version + '.0',
    m_channel: '',
    network_type: '',
    log_time: common.getTemServerTime() + '',
    LANIP: common.LANIP, //内网ip
    WANIP: common.WANIP, //外网IP
    user_id: (common.getSession('userID') || '') + '',
    course_id: (common.getSession('class_id') || '') + '',
    sclass_id: (common.getSession('smallClassId') || '') + '',
    hmaster_id: '',
    teacher_id: (common.getSession('teacher_id') || '') + '',
    lesson_id: (common.getSession('lesson_id') || '') + '',
    biz_id: '5001',
    biz_data: {
      playTime: data.duration ? data.duration : 0,
    },
  };
  //
  logger.info(commonData);

  /*伪直播再上报5001*/
  if (
    data.duration > 0 &&
    data.data &&
    (data.data.class_type == 10 || data.data.isPlayback)
  ) {
    logger.info(durationData);
  }

  //console.log(JSON.stringify(commonData))
}

function onLimiLog(logs) {
  const base_data = readHeader() || baseData;
  const msg_data = [];
  for (let i = 0; i < logs.length; i++) {
    msg_data.push(logs[i][2]);
  }
  const data = { base_data, msg_data };

  return JSON.stringify(data);
}

//todo 公共头
writeHeader(baseData);

function getUploadUrl() {
  return common.API ? common.API['900001'] : '';
}
const logger = Logger.getInstance('dbLog', 0, getUploadUrl, onLimiLog, 30000);
// const track = new TrackPoint(logger, onLimiTrack);

export { createBLog, logger };



// WEBPACK FOOTER //
// ./src/js/log.js